import {Button, Col, Divider, Form, Row, Space, Spin} from "antd";
import React, {useState, useEffect, useRef, useMemo} from "react";
import {ReactComponent as ExpandIconSVG} from "assets/images/svg/expand.svg";
import "./Receive.scss";
import HealthInsuranceInfo from "./components/HealthInsuranceInfo/HealthInsuranceInfo";
import PolicyInfo from "./components/PolicyInfo/PolicyInfo";
import PatientWaiter from "./components/PatientWaiter/PatientWaiter";
import {receiveSetFieldsValue, InsuranceDataType} from "./config";
import {medicalExaminationService, sharedDirectory} from "api";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {RECEIVE_ACTION_TYPE} from "types/enums/receive-action-type";
import {FORMAT_TIME, tabKeys} from "types/enums";
import {setActiveKey, setIdPhieuKham, setSiderKey} from "redux/reducer/common";
import {setAction} from "redux/reducer/receive";
import {useNavigate} from "react-router-dom";
import SignSecure from "./components/SignSecure/SignSecure";
import MainInfo from "./components/MainInfo/MainInfo";
import ExpandInfo from "./components/ExpandInfo/ExpandInfo";
import RelativeInfo from "./components/RelativeInfo/RelativeInfo";
import ReceiveInfo from "./components/ReceiveInfo/ReceiveInfo";
import RegisterInfo from "./components/RegisterInfo/RegisterInfo";
import {birthday2Age, removeSpaces} from "helper/common";
import {setPatientRecord} from "redux/reducer/patientRecord";
import Notification from "components/common/notification/notification";
import {setReload} from "redux/reducer/receiveReload";
import CancelModal from "./components/CancelModal/CancelModal";
import ExanRegBill from "./components/ExamRegBill/ExamRegBill";
import {setId} from "redux/reducer/reduxCommon";
import dayjs from "dayjs";
import CheckNullApi from "components/common/CheckNullApi/CheckNullApi";

// 0 = post, 1= put
// const saveData = async (values, type = 0) => {
//   let response;
//   const data = {
//     ...values,
//     ngaySinh: values.ngaySinh ? values.ngaySinh.toISOString() : null,
//     ngaySinhThanNhan: values.ngaySinhThanhNhan
//       ? values.ngaySinhThanNhan.toISOString()
//       : null,
//     ngayNhapVien: values.ngayNhapVien
//       ? values.ngayNhapVien.toISOString()
//       : null,
//     tuoi: null,
//   };
//   if (type == 0) {
//     response = await medicalExaminationService.postMedicalBill(data);
//   } else {
//     response = await medicalExaminationService.putMedicalBill(data);
//   }
//   return response;
// };

const Detail = () => {
  const dispatch = useAppDispatch();
  const searchPatient = useAppSelector(state => state.searchPatient);
  const [provinces, setProvinces] = useState();
  const [appliedPolicy, setAppliedPolicy] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [expandMoreInfo, setExpandMoreInfo] = useState<boolean>(false);
  const [expandRelativeInfo, setExpandRelativeInfo] = useState<boolean>(false);
  const signSecureRef = useRef<any>();
  const examRef = useRef<any>();
  const [form] = Form.useForm();

  const onShowModalSignSecure = e => {
    signSecureRef.current?.setData(form.getFieldsValue());
    signSecureRef.current?.openModal();
  };

  const resetFormField = () => {
    form.resetFields();
    form.setFieldsValue({
      xa: null,
      huyen: null,
      tinh: null,
      gioiTinh: null,
      gioiTinhThanNhan: null,
      quanHeThanNhan: null,
      loaiKCB: null,
      dichVu: null,
      phong: null,
      doiTuong: null,
      nguonBn: null,
      danToc: 0,
      ngheNghiep: "Nghề khác",
    });
  };

  //lần đàu tiên vào sẽ kiểm tra là loại thực hiện hành động là gì?
  useEffect(() => {
    setLoading(true);

    resetFormField();
    setAppliedPolicy([]);
    receiveSetFieldsValue(form, {
      ...searchPatient?.dataPassing,
      maBenhNhan: searchPatient?.dataPassing?.maBenhNhan,
    });
    setAppliedPolicy(searchPatient?.dataPassing?.chinhSachApDungs);
    dispatch(setIdPhieuKham(searchPatient?.dataPassing?.id));
    //kiểm tra xem cso phải là BN mới

    //Kiểm tra xem cso phải là phiếu khám mới

    setLoading(false);
  }, [searchPatient]);
  //check xem có đủ api chưa?
  useEffect(() => {
    CheckNullApi();
    const fetchProvinces = async () => {
      try {
        let response = await sharedDirectory.getListProvince();
        setProvinces(response.data);
      } catch (err) {
        Notification("error", "Lỗi khi lấy danh mục tỉnh");
      }
    };
    fetchProvinces();
  }, []);

  return (
    <Spin spinning={loading}>
      <Row className="receive-container">
        <Space direction="horizontal" align="start" size={24}>
          <Row className="receive-item">
            <Row
              justify={"space-between"}
              style={{
                marginBottom: "12px",
              }}
            >
              <Col>
                <Button
                  type="ghost"
                  className="btn-sub"
                  onClick={onShowModalSignSecure}
                >
                  Ký bảo mật thông tin
                </Button>
                <SignSecure modalRef={signSecureRef} />
              </Col>
              <Col>
                <Row justify={"end"}>
                  {!expandMoreInfo ? (
                    <Button
                      icon={<ExpandIconSVG />}
                      className="expand-icon-button"
                      onClick={() => setExpandMoreInfo(!expandMoreInfo)}
                    >
                      Thông tin mở rộng
                    </Button>
                  ) : null}
                  {!expandRelativeInfo ? (
                    <Button
                      icon={<ExpandIconSVG />}
                      className="expand-icon-button"
                      onClick={() => setExpandRelativeInfo(!expandRelativeInfo)}
                    >
                      Nhân thân
                    </Button>
                  ) : null}
                </Row>
              </Col>
            </Row>
            <Space direction="vertical">
              {/* Thông tin chính */}
              <MainInfo {...{form: form, provinces: provinces}} />
              {expandMoreInfo ? <Divider type="horizontal" /> : null}
              {/* Mở rộng thoogn tin */}
              <ExpandInfo
                {...{
                  form: form,
                  expandMoreInfo: expandMoreInfo,
                  setExpandMoreInfo: setExpandMoreInfo,
                }}
              />
              {expandRelativeInfo ? <Divider type="horizontal" /> : null}
              <RelativeInfo
                {...{
                  form: form,
                  expandRelativeInfo: expandRelativeInfo,
                  setExpandRelativeInfo: setExpandRelativeInfo,
                  provinces: provinces,
                }}
              />
              <Divider type="horizontal" />
              <ReceiveInfo {...{form: form}} />
              <Divider type="horizontal" />
              <RegisterInfo {...{form: form}} />
            </Space>
          </Row>
          <Row>
            <Space direction="vertical" size={16}>
              <HealthInsuranceInfo {...{form: form}} />
              <PolicyInfo
                {...{
                  appliedPolicy: appliedPolicy,
                  setAppliedPolicy: setAppliedPolicy,
                }}
              />
              {/* <PatientWaiter /> */}
            </Space>
          </Row>
        </Space>
        <ExanRegBill modalRef={examRef} />
        {/* <CancelModal ref={cancelRef} onCancelOk={handleCancelOk} /> */}
      </Row>
    </Spin>
  );
};

export default Detail;
